module.exports = {
	"articleTitle1": "Students and faculty start RC Garden at East Quad ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "East Quad",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/opinion/11viewpoint-new-east-quad-sucks11",
	"articleSnippet1": "Oct 4, 2015 ... Tomatoes and cucumbers are ripening in gardens across Michigan, including a \nnew plot on East Quad's grounds.",
	"articleSnippet2": "Nov 10, 2013 ... I lived in East Quad Residence Hall my freshman year, and though it took some \ntime, I grew into the RC lifestyle. I walked around the building ...",
	"totalMisc": 1,
	"articleTitle2": "Viewpoint: East Quad's a home, not a hotel",
	"address": "701 E University Ave, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/asg.eastquad.IMG_2181%20copy_0%20copy.jpg",
			"author": "Adam Glanzman",
			"caption": "Freshmen move into the newly renovated East Quadrangle building on August 26, 2013."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/151004/ksp.NEW_.RCgarden.10.2.15.048.jpg?itok=Fb_RSPHV",
			"author": "San Pham",
			"caption": "LSA sophomore Darian Razdar, Residential College Director John Wells and Residential College Professor Virginia Murphy cut the celebratory ribbon at the opening of the Residential College Garden at East Quad on Friday."
		}
	],
	"position": {
		"lat": 42.272934,
		"lng": -83.735231
	},
	"tips": [
		{
			"text": "You can watch TV down there (basement), there's never anyone watching anything unless the Bachelor is on",
			"person": "Rebecca Lerner"
		},
		{
			"text": "EQ Dining goes all vegetarian on Mondays.",
			"person": "Abe Lofy"
		}
	],
	"bathroomrating": [
		{
			"rating": 3,
			"bathroom": "Bathroom off the Green Lounge across from the huddle room"
		},
		{
			"rating": 3,
			"bathroom": "Lobby Bathroom"
		}
	],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/eastquad.json
// module id = 870
// module chunks = 0